var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChallengesPending(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#F4F7FE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.2841 24.3135H20.5578C21.6115 24.3135 22.4736 25.1756 22.4736 26.2293V35.8081C22.4736 36.8618 21.6115 37.7239 20.5578 37.7239H20.2841C19.2305 37.7239 18.3684 36.8618 18.3684 35.8081V26.2293C18.3684 25.1756 19.2305 24.3135 20.2841 24.3135ZM27.9472 18.5663C29.0009 18.5663 29.863 19.4284 29.863 20.482V35.8081C29.863 36.8618 29.0009 37.7239 27.9472 37.7239C26.8935 37.7239 26.0314 36.8618 26.0314 35.8081V20.482C26.0314 19.4284 26.8935 18.5663 27.9472 18.5663ZM35.6103 29.5135C36.6639 29.5135 37.526 30.3756 37.526 31.4292V35.8081C37.526 36.8618 36.6639 37.7239 35.6103 37.7239C34.5566 37.7239 33.6945 36.8618 33.6945 35.8081V31.4292C33.6945 30.3756 34.5566 29.5135 35.6103 29.5135Z",
    fill: "#FF7A00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_8"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.8417,
    height: 32.8417,
    fill: "white",
    transform: "translate(11.5264 11.7242)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChallengesPending);
export default __webpack_public_path__ + "static/media/challenges-pending.9e519cd1547bec9e219623130bf70bf0.svg";
export { ForwardRef as ReactComponent };